import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
} from "client/components"

const Details = () => {
    const item = useSelector((state: StoreType) => state.ccReviewReview.itemDetails)
    const typeList = useSelector((state: StoreType) => state.ccReviewReviewType.typeList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.reviewItem}</Label>
                        <Textarea value={item.remark} readOnly />
                    </FormGroup>

                    <Row>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>{lang.seePage}</Label>
                                <Input type="text" value={item.page} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>{lang.kind}</Label>
                                <Input type="text" value={typeList[item.typeId] ? typeList[item.typeId].name : ""} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>{lang.revision}</Label>
                                <Input type="text" value={item.version ? item.version.revision : ""} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Details
